module.exports = __webpack_public_path__ + "img/headerimage.5bbe79af.png";